<template>
  <div>
    <div class="flex justify-between items-center mb-4">
      <div class="flex items-end">
        <div class="mr-2">
          <label class="vs-input--label pl-1">Месяц:</label>
          <elsa-v-datepicker
            v-model="selectedDate"
            view-format="LLLL yyyy"
            :datepicker-props="{minimumView: 'month'}"
            :clearable="false"
          />
        </div>
        <div class="mr-4">
          <vs-button
            type="border"
            @click="openGenerate()"
            v-if="$can('rp.kv', 'write')"
          >
            Генерация квитанций
          </vs-button>
        </div>
      </div>

      <div class="flex justify-end">
        <label class="mr-4">только мои</label>
        <vs-switch v-model="showOnlyMyGenerateHistory" />
      </div>
    </div>

    <vs-table
      :data="invoicesHistoryFiltered" max-items="10" pagination class="w-full"
      noDataText="История генераций пуста"
    >
      <template slot="thead">
        <vs-th>Дата и время</vs-th>
        <vs-th>Месяц</vs-th>
        <vs-th>Тип помещения</vs-th>
        <vs-th>Статус</vs-th>
        <vs-th>Сгенерировано</vs-th>
        <vs-th>Ошибок</vs-th>
        <vs-th>Автор</vs-th>
        <vs-th />
        <vs-th />
      </template>

      <template slot-scope="{data}" ref="content">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>{{ $options.filters.moment(tr.created_at, 'DD.MM.YYYY HH:mm:ss') }}</vs-td>
          <vs-td>{{
              tr.log && JSON.parse(tr.log).month ?
                $options.filters.moment($parseDateFromString(JSON.parse(tr.log).month), "MMMM YYYY") : ''
            }}
          </vs-td>
          <vs-td>{{ getApartmentTypeName(tr.log) }}
          </vs-td>

          <vs-td>
            <template v-if="tr.status === HISTORY_STATUSES.done">
              <div class="flex items-center">
                <feather-icon
                  icon="CheckCircleIcon" svg-classes="text-success" class="mr-2"
                  title="Генерация завершена"
                />
                <span>завершено</span>
              </div>
            </template>
            <template v-else-if="tr.status === HISTORY_STATUSES.process">
              <div class="flex items-center">
                <feather-icon icon="ClockIcon" svg-classes="text-warning" class="mr-2" title="Генерация в процессе" />
                <vs-progress :percent="Number(tr.percent)" color="warning" :title="tr.percent" />
              </div>
            </template>
            <template v-else-if="tr.status === HISTORY_STATUSES.error">
              <div class="flex items-center">
                <feather-icon
                  icon="XCircleIcon" svg-classes="text-danger" class="mr-2"
                  title="Ошибка"
                />
                <span>ошибка</span>
              </div>
            </template>
          </vs-td>

          <vs-td>{{ tr.success !== null ? tr.success : '-' }}</vs-td>
          <vs-td>{{ tr.denied !== null ? tr.denied : '-' }}</vs-td>
          <vs-td>{{ tr.who ? tr.who.name : 'Не известно' }}</vs-td>
          <vs-td>
            <template v-if="tr.log && JSON.parse(tr.log).zip_anchor">
              <a
                :href="link | imgPath"
                @click.stop
                download
                v-for="(link, index) in JSON.parse(tr.log).zip_anchor"
                :key="'link' + index"
                :title="getApartmentTypeById(index)"
                target="_blank"
              >
                <feather-icon icon="DownloadIcon" svg-classes="text-primary" class="cursor-pointer" />
              </a>
            </template>
          </vs-td>
          <vs-td><a
            href="#" @click.prevent="openGenerateLog(tr)"
            v-if="tr.status === HISTORY_STATUSES.done"
          >подробнее</a></vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import notifyHttpError      from "@/mixins/notifyHttpError";
import quarterDisabledDates from "@/mixins/quarterDisabledDates";
import { ru }               from 'vuejs-datepicker/dist/locale';

const HISTORY_STATUSES = {
  process: 0,
  done:    1,
  error:   2,
};

export default {
  name:   "InvoicesGenerateHistoryPopup",
  mixins: [quarterDisabledDates, notifyHttpError],
  data() {
    return {
      invoicesHistory:           null,
      showOnlyMyGenerateHistory: false,
      loadInterval:              null,
      ru,
      HISTORY_STATUSES,
    };
  },
  computed: {
    userId() {
      return this.$store.getters['appUser/id'];
    },

    selectedDate: {
      get() {
        return new Date(this.$store.getters['appUser/selectedDate']) || null;
      },
      set( value ) {
        this.$store.dispatch('appUser/SET_DATE', value);
      },
    },

    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },

    apartmentsTypes() {
      return this.$store.getters['appUser/availableApartmentsTypes'];
    },

    invoicesHistoryFiltered() {
      let history = this.invoicesHistory;
      if (!history) return [];
      if (this.showOnlyMyGenerateHistory) {
        history = history.filter(historyLocal => historyLocal.who && historyLocal.who.id === this.userId);
      }
      return history;
    },
  },
  methods:  {
    getApartmentTypeName( log ) {
      if (!log) return '';
      const { apartments_type } = JSON.parse(log);
      if (apartments_type === null || apartments_type === undefined) return 'Все';
      return this.getApartmentTypeById(apartments_type);
    },

    openGenerate() {
      this.$modal.open({
        size:      'sm',
        title:     'Генерация квитанций',
        component: () => import('@/components/calculated-program/invoices/InvoicesGeneratePopup'),
      });
    },

    openGenerateLog( historyItem ) {
      this.$modal.open({
        // size:           '',
        title:          'Подробнее о генерации',
        component:      () => import('@/components/calculated-program/invoices/InvoicesGenerateLogPopup'),
        componentProps: { historyItem },
      });
    },

    loadHistory() {
      return this.$http.get('kv_status', { params: { buildings_id: this.selectedHouseId } }).then(( { data } ) => {
        this.invoicesHistory = data;
      });
    },

    getApartmentTypeById( id ) {
      if (Number(id) === 999) return 'Все';
      let type = this.apartmentsTypes.find(type => Number(type.id) === Number(id));
      return type ? type.name : '';
    },
  },
  mounted() {
    this.loadHistory();
    this.loadInterval = setInterval(this.loadHistory, 3000);
  },
  beforeDestroy() {
    if (this.loadInterval) clearInterval(this.loadInterval);
  },
  watch: {},
};
</script>

<style lang="scss" module>

</style>
